import styled from 'styled-components';
import { Link } from 'gatsby';

export const MenuItemLink = styled(Link)`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : 'DINBold ')};
  display: flex;
  flex-flow: column;
  justify-content: center;
  height: 50px;
  padding: 0 20px;
  color: #fff;
  transition: all 0.3s;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
  text-decoration: none;
  align-items: center;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '')};

  @media (max-width: 575.98px) {
    padding: 0 10px;
  }

  @media (max-width: 350px) {
    padding: 0 10px;
  }
    
  &[dir='ltr'] {
    &.about_menu {
      font-size: 10px;
    }
  }
  &[dir='rtl'] {
    &.about_menu {
      font-size: 14px;
      font-family: 'GESSTwoDWTCLight', sans-serif;
    }
  }
  &.sustainability-page {
    color: #000!important;
    background: #f0f0f0!important;
    opacity: 1!important;
  }
  &.about_menu {
    color: #fff;
    opacity: 0.7;
    &[dir='ltr'] {
      font-family: 'DINRegular';
    }
    &.active,
    &[aria-current='page'] {
      color: #000;
      background: #f0f0f0;
      opacity: 1;

      @media (max-width: 1099px) {
        color: #000!important;
      }
    }
  }
`;
